import { render } from "./BuyCoins.vue?vue&type=template&id=167acbbe&scoped=true"
import script from "./BuyCoins.vue?vue&type=script&lang=js"
export * from "./BuyCoins.vue?vue&type=script&lang=js"

import "./BuyCoins.vue?vue&type=style&index=0&id=167acbbe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167acbbe"]])

export default __exports__